import {Component, Inject, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Order} from '../../models/order.model';
import {OrderService} from '../../services/order.service';
import { Quotation } from '../../models/quotation.model';
import { QuotationService } from '../../services/quotation.service';

@Component({
    selector: 'app-confirm-email',
    templateUrl: './confirm-email.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ConfirmEmailComponent implements OnInit {
  public order: Order;
  public quotation: Quotation;
  public mode: number;
  public progress = false;

  constructor(
    public dialogRef: MatDialogRef<ConfirmEmailComponent>,
    private orderService: OrderService,
    private quotationService: QuotationService,
    @Inject(MAT_DIALOG_DATA) public data: { quotation: Quotation, order: Order, mode: number }) {
  }

  public ngOnInit(): void {
    this.quotation = this.data.quotation;
    this.order = this.data.order;
    this.mode = this.data.mode;
  }

  /**
   * Close dialog without any action
   */
  public cancel(): void {
    this.dialogRef.close(false);
  }

  /**
   * Send the email (file email if mode is 1 else BAT email)
   * Close dialog if the email sent successfully
   */
  public send(): void {
    this.progress = true;
    if (this.quotation) {
      this.quotationService.sendEmail(this.quotation.id)
        .then(() => this.dialogRef.close(true))
        .catch(err => console.error(err))
        .finally(() => this.progress = false);
      return;
    }
    if (this.mode === 0) {
      this.orderService.sendFileEmail(this.order.id)
        .then(() => this.dialogRef.close(true))
        .catch(err => console.error(err))
        .finally(() => this.progress = false);
      return;
    }
    if (this.mode === 1) {
      this.orderService.sendBatEmail(this.order.id)
        .then(() => this.dialogRef.close(true))
        .catch(err => console.error(err))
        .finally(() => this.progress = false);
    }
  }
}
